// Mock data for Gujarat Women & Child Development Department

export const heroData = {
  title: "Gujarat Women & Child Development Department",
  subtitle: "Empowering Women & Ensuring Child Development Through AI-Driven Governance",
  description: "Leading comprehensive development programs for women empowerment and child nutrition in Gujarat through innovative technology and data-driven decision making.",
  stats: [
    { label: "Anganwadi Centers", value: "53,065" },
    { label: "Districts Covered", value: "41" },
    { label: "Women Beneficiaries", value: "16.49L" },
    { label: "Children Served", value: "7.68L" }
  ]
};

export const dashboardMetrics = {
  childDevelopment: [
    { title: "Child Nutrition Coverage", value: 92, unit: "%", trend: "+8%" },
    { title: "Anganwadi Digitization", value: 78, unit: "%", trend: "+15%" },
    { title: "Immunization Rate", value: 94, unit: "%", trend: "+6%" },
    { title: "Pre-School Enrollment", value: 87, unit: "%", trend: "+12%" }
  ],
  womenEmpowerment: [
    { title: "Vahli Dikri Beneficiaries", value: 2.3, unit: "L", trend: "+19%" },
    { title: "Widow Pension Coverage", value: 16.49, unit: "L", trend: "+8%" },
    { title: "Violence Prevention Cases", value: 91, unit: "%", trend: "+14%" },
    { title: "Women Skill Training", value: 1.2, unit: "L", trend: "+23%" }
  ]
};

export const aiServices = [
  {
    title: "Predictive Malnutrition Analytics",
    description: "AI-powered prediction of child malnutrition using health data, satellite imagery, and demographic patterns for proactive intervention.",
    impact: "89% accuracy in malnutrition prediction",
    icon: "Heart"
  },
  {
    title: "Face Recognition System (FRS)",
    description: "Biometric authentication system for transparent Take-Home Ration distribution and beneficiary verification in Anganwadi centers.",
    impact: "Eliminated leakages and duplication",
    icon: "Shield"
  },
  {
    title: "Automated Resource Allocation",
    description: "ML algorithms optimizing distribution of nutritional supplements, medical supplies, and staff allocation across 53,065 Anganwadi centers.",
    impact: "68% improvement in service delivery",
    icon: "Target"
  },
  {
    title: "AI-Powered Helpline Assistant",
    description: "Intelligent chatbot for 181 Mahila Helpline providing 24/7 support, emergency response, and violence prevention guidance.",
    impact: "91% case resolution rate",
    icon: "MessageSquare"
  },
  {
    title: "Sentimental Analysis",
    description: "AI-powered sentiment analysis of feedback from beneficiaries, staff, and community members to improve WCD service delivery and program effectiveness.",
    impact: "84% improvement in service satisfaction",
    icon: "MessageCircle"
  },
  {
    title: "Telemetry",
    description: "Advanced IoT and sensor-based telemetry system for real-time monitoring of Anganwadi centers, equipment status, and service delivery metrics.",
    impact: "91% operational efficiency improvement",
    icon: "Activity"
  },
  {
    title: "Policy Simulator",
    description: "Advanced AI-driven simulation platform for designing, testing, and optimizing WCD schemes before implementation through digital twin modeling and predictive analytics.",
    impact: "87% improvement in scheme effectiveness",
    icon: "Settings"
  }
];

export const mapData = {
  districts: [
    // Central Gujarat
    { name: "Ahmedabad", anganwadiCenters: 3245, nutritionScore: 94, lat: 23.0225, lng: 72.5714, region: "Central Gujarat" },
    { name: "Gandhinagar", anganwadiCenters: 1852, nutritionScore: 92, lat: 23.2156, lng: 72.6369, region: "Central Gujarat" },
    { name: "Anand", anganwadiCenters: 1967, nutritionScore: 91, lat: 22.5645, lng: 72.9289, region: "Central Gujarat" },
    { name: "Kheda", anganwadiCenters: 2134, nutritionScore: 89, lat: 22.7156, lng: 72.6844, region: "Central Gujarat" },
    
    // North Gujarat
    { name: "Patan", anganwadiCenters: 1789, nutritionScore: 87, lat: 23.8315, lng: 72.1288, region: "North Gujarat" },
    { name: "Mehsana", anganwadiCenters: 2045, nutritionScore: 88, lat: 23.5880, lng: 72.3693, region: "North Gujarat" },
    { name: "Sabarkantha", anganwadiCenters: 2387, nutritionScore: 85, lat: 23.9045, lng: 73.0553, region: "North Gujarat" },
    { name: "Banaskantha", anganwadiCenters: 3156, nutritionScore: 83, lat: 24.1719, lng: 72.4389, region: "North Gujarat" },
    
    // Saurashtra
    { name: "Rajkot", anganwadiCenters: 2876, nutritionScore: 90, lat: 22.3039, lng: 70.8022, region: "Saurashtra" },
    { name: "Jamnagar", anganwadiCenters: 2134, nutritionScore: 86, lat: 22.4707, lng: 70.0577, region: "Saurashtra" },
    { name: "Porbandar", anganwadiCenters: 987, nutritionScore: 84, lat: 21.6417, lng: 69.6293, region: "Saurashtra" },
    { name: "Junagadh", anganwadiCenters: 1876, nutritionScore: 85, lat: 21.5222, lng: 70.4579, region: "Saurashtra" },
    { name: "Amreli", anganwadiCenters: 1543, nutritionScore: 82, lat: 21.5985, lng: 71.2153, region: "Saurashtra" },
    { name: "Bhavnagar", anganwadiCenters: 2234, nutritionScore: 87, lat: 21.7645, lng: 72.1519, region: "Saurashtra" },
    { name: "Surendranagar", anganwadiCenters: 1765, nutritionScore: 81, lat: 22.7196, lng: 71.6369, region: "Saurashtra" },
    { name: "Morbi", anganwadiCenters: 1234, nutritionScore: 83, lat: 22.8173, lng: 70.8378, region: "Saurashtra" },
    { name: "Devbhoomi Dwarka", anganwadiCenters: 987, nutritionScore: 80, lat: 22.2394, lng: 68.9678, region: "Saurashtra" },
    { name: "Gir Somnath", anganwadiCenters: 1123, nutritionScore: 81, lat: 20.8773, lng: 70.4021, region: "Saurashtra" },
    { name: "Botad", anganwadiCenters: 876, nutritionScore: 79, lat: 22.1692, lng: 71.6661, region: "Saurashtra" },
    
    // Kutch
    { name: "Kutch", anganwadiCenters: 2567, nutritionScore: 78, lat: 23.7337, lng: 69.8597, region: "Kutch" },
    
    // South Gujarat
    { name: "Surat", anganwadiCenters: 4123, nutritionScore: 93, lat: 21.1702, lng: 72.8311, region: "South Gujarat" },
    { name: "Bharuch", anganwadiCenters: 1567, nutritionScore: 88, lat: 21.7051, lng: 72.9959, region: "South Gujarat" },
    { name: "Narmada", anganwadiCenters: 987, nutritionScore: 86, lat: 21.8756, lng: 73.4206, region: "South Gujarat" },
    { name: "Navsari", anganwadiCenters: 1234, nutritionScore: 89, lat: 20.9463, lng: 72.9270, region: "South Gujarat" },
    { name: "Valsad", anganwadiCenters: 1456, nutritionScore: 87, lat: 20.5992, lng: 72.9342, region: "South Gujarat" },
    { name: "Dang", anganwadiCenters: 234, nutritionScore: 75, lat: 20.7489, lng: 73.7294, region: "South Gujarat" },
    { name: "Tapi", anganwadiCenters: 765, nutritionScore: 84, lat: 21.1167, lng: 73.4167, region: "South Gujarat" },
    
    // East Gujarat
    { name: "Vadodara", anganwadiCenters: 3456, nutritionScore: 91, lat: 22.3072, lng: 73.1812, region: "East Gujarat" },
    { name: "Panchmahals", anganwadiCenters: 2134, nutritionScore: 83, lat: 22.8259, lng: 73.6008, region: "East Gujarat" },
    { name: "Dahod", anganwadiCenters: 1876, nutritionScore: 79, lat: 22.8396, lng: 74.2663, region: "East Gujarat" },
    { name: "Mahisagar", anganwadiCenters: 1123, nutritionScore: 81, lat: 23.2156, lng: 73.6500, region: "East Gujarat" },
    { name: "Chhota Udepur", anganwadiCenters: 876, nutritionScore: 77, lat: 22.3048, lng: 74.0156, region: "East Gujarat" },
    { name: "Aravalli", anganwadiCenters: 987, nutritionScore: 80, lat: 23.1019, lng: 73.0553, region: "East Gujarat" }
  ]
};

export const chatbotResponses = {
  welcome: "Welcome to Gujarat WCD Assistant! I can help you with information about women & child development schemes, nutrition programs, and support services. How may I assist you today?",
  services: [
    "Anganwadi Services Information",
    "Women Empowerment Schemes", 
    "Child Nutrition Programs",
    "Vahli Dikri Yojana Details",
    "Violence Prevention Support"
  ]
};

export const newsUpdates = [
  {
    title: "Gujarat Launches Face Recognition System for Anganwadi Transparency",
    date: "2025-01-15",
    summary: "Mission Saksham Anganwadi implements FRS technology to eliminate leakages in Take-Home Ration distribution across 53,065 centers.",
    category: "Technology & Transparency"
  },
  {
    title: "Anganwadi Worker Wages Increased Significantly",
    date: "2025-01-12", 
    summary: "Gujarat High Court mandates wage increase for 1.06 lakh Anganwadi workers - monthly wages rise to Rs. 24,800 for workers and Rs. 20,300 for helpers.",
    category: "Workers Welfare"
  },
  {
    title: "Mukhyamantri Matrushakti Yojana Reaches 2 Lakh Beneficiaries",
    date: "2025-01-08",
    summary: "First 1000 days nutrition program provides comprehensive support to new mothers and children across Gujarat.",
    category: "Child Development"
  }
];

export const partnerships = [
  { name: "UNICEF", logo: "/api/placeholder/120/60", focus: "Child Development Programs" },
  { name: "National Institute of Nutrition", logo: "/api/placeholder/120/60", focus: "Nutrition Research & Guidelines" },
  { name: "Savitribai Phule Institute", logo: "/api/placeholder/120/60", focus: "Training & Capacity Building" },
  { name: "MGNREGA", logo: "/api/placeholder/120/60", focus: "Infrastructure Development" },
  { name: "CSR Organizations", logo: "/api/placeholder/120/60", focus: "Corporate Social Responsibility" },
  { name: "District Cooperative Dairies", logo: "/api/placeholder/120/60", focus: "Milk Distribution Programs" }
];

// WCD Schemes and Programs Data
export const wcdSchemes = {
  childDevelopment: [
    {
      id: "icds",
      name: "Integrated Child Development Services (ICDS)",
      description: "Comprehensive program providing nutrition, health, and education services to children under 6 and pregnant/lactating mothers through 53,065 Anganwadi centers.",
      launched: "1975",
      coverage: {
        rural: 29468,
        tribal: 13315,
        urban: 10246
      },
      services: ["Supplementary Nutrition", "Pre-school Education", "Health Check-ups", "Immunization", "Referral Services", "Health & Nutrition Education"],
      budget: "₹2,156 Crore",
      beneficiaries: "45 Lakh Children"
    },
    {
      id: "nandghar",
      name: "Nandghar Initiative",
      description: "Transformation of traditional Anganwadi centers into modern, well-equipped facilities with toilets, drinking water, electricity, halls, kitchens, and storage rooms.",
      launched: "2017",
      unitCost: {
        rural: "₹12 Lakh (MGNREGA)",
        urban: "100% State Funding"
      },
      features: ["Solar & Grid Electricity", "Water Purifiers", "LED TVs", "Tablets", "Child-friendly Furniture"],
      completed: "15,000+ Centers"
    },
    {
      id: "thr",
      name: "Take Home Ration (THR) Scheme",
      description: "Fortified food packets distribution to children aged 6 months to 6 years, pregnant and lactating mothers, and severely underweight children.",
      target: ["Children 6m-6y", "Pregnant Women", "Lactating Mothers", "Underweight Children"],
      content: "Ready-to-cook balanced nutrition packets",
      distribution: "Monthly through Anganwadi Centers"
    },
    {
      id: "dudh-sanjeevani",
      name: "Dudh Sanjeevani Yojana",
      description: "Daily 200ml fortified milk provision to tribal students in primary schools and Ashramshalas across 52 talukas in 14 districts.",
      launched: "2006-07",
      composition: {
        fat: "3%",
        carbohydrates: "24g",
        protein: "7g",
        vitaminA: "500 I.U.",
        vitaminD: "40 I.U."
      },
      beneficiaries: "7,68,465 Children",
      schools: "8,958 Schools",
      budget: "₹270 Crore"
    },
    {
      id: "matrushakti",
      name: "Mukhyamantri Matrushakti Yojana",
      description: "First 1000 days nutrition program from conception to child's second birthday, providing nutrition kits to first-time mothers.",
      launched: "June 18, 2022",
      portal: "https://1000d.gujarat.gov.in/",
      nutritionKit: ["1L Groundnut Oil", "1Kg Tuver Dal", "2Kg Chana"],
      duration: "From pregnancy to child's 2nd birthday",
      target: "First-time Pregnant Women"
    }
  ],
  womenEmpowerment: [
    {
      id: "vahli-dikri",
      name: "Vahli Dikri Yojana",
      description: "Financial incentive scheme encouraging families to educate and nurture daughters through monetary support at key educational milestones.",
      launched: "August 1, 2019",
      benefits: {
        class1: "₹4,000",
        class9: "₹6,000",
        age18: "₹1,00,000 (Higher Studies/Marriage)"
      },
      eligibility: "First 3 children, Annual income ≤ ₹2,00,000",
      beneficiaries: "2.3 Lakh Girls"
    },
    {
      id: "ganga-swarupa",
      name: "Ganga Swarupa Pension Scheme",
      description: "Monthly financial assistance to widow women providing lifetime support for dignity and independence.",
      launched: "1979",
      monthlyAmount: "₹1,250",
      budget: "₹3,015 Crore (2025-26)",
      beneficiaries: "16.49 Lakh Women",
      eligibility: {
        rural: "Annual income ≤ ₹1,20,000",
        urban: "Annual income ≤ ₹1,50,000"
      }
    },
    {
      id: "swavlamban",
      name: "Mahila Swavlamban Yojana",
      description: "Financial assistance to rural and urban women below poverty line for undertaking economic activities and achieving self-sufficiency.",
      target: "Women Below Poverty Line",
      focus: "Economic Independence",
      activities: ["Small Business", "Skill Development", "Microfinance"]
    }
  ],
  violencePrevention: [
    {
      id: "abhayam-181",
      name: "Abhayam 181 Mahila Helpline",
      description: "24/7 helpline service across all districts providing guidance and support to women facing violence with police action desks and mobile applications.",
      availability: "24/7 All Districts",
      services: ["Emergency Response", "Guidance & Counseling", "Police Action Desk", "Mobile App Support"],
      features: ["Immediate Assistance", "Rescue Services", "Silent Alerts"]
    },
    {
      id: "sakhi-osc",
      name: "Sakhi One Stop Centers",
      description: "Integrated support centers providing comprehensive services under one roof for women affected by violence regardless of background.",
      services: ["Emergency Response", "Medical Assistance", "Legal Aid", "Counseling", "Psycho-social Support", "Temporary Shelter"],
      coverage: "All women irrespective of age, class, caste, education, marital status"
    },
    {
      id: "police-support",
      name: "Police Station Based Support Centers",
      description: "Counseling and legal support centers in district police stations for women victims of violence.",
      locations: "63 Centers in 33 Districts",
      services: ["Counseling", "Legal Information", "Police Complaint Assistance"]
    },
    {
      id: "swadhar-gruh",
      name: "Swadhar Gruh",
      description: "Accommodation and rehabilitation facilities for women in difficult situations integrating shelter and support services.",
      facilities: "8 Centers Statewide",
      funding: "60:40 Central-State Pattern",
      target: "Women in Difficult Circumstances"
    }
  ]
};

// Performance Metrics and KPIs
export const wcdMetrics = {
  overview: {
    totalAnganwadi: 53065,
    totalBeneficiaries: 4500000,
    budgetAllocation: 8500,
    schemesCovered: 15,
    districtsCovered: 33
  },
  nutritionMetrics: {
    malnutritionReduction: 23,
    immunizationCoverage: 94,
    supplementaryNutrition: 92,
    takeHomeRation: 89
  },
  womenEmpowermentMetrics: {
    vahliDikriBeneficiaries: 230000,
    widowPensionCoverage: 1649000,
    violencePreventionSuccess: 91,
    skillTrainingCompleted: 120000
  },
  technologyMetrics: {
    digitalLiteracy: 78,
    frsImplementation: 65,
    onlineServices: 84,
    dataAnalyticsUsage: 71
  }
};

// Download functionality for WCD data
export const downloadData = {
  schemes: {
    childDevelopment: [
      {
        id: "icds",
        name: "Integrated Child Development Services (ICDS)",
        beneficiaries: 4500000,
        budget: 2156,
        centers: 53065,
        services: ["Supplementary Nutrition", "Pre-school Education", "Health Check-ups", "Immunization"]
      },
      {
        id: "nandghar", 
        name: "Nandghar Initiative",
        completed: 15000,
        unitCost: 12,
        features: ["Solar Electricity", "Water Purifiers", "LED TVs", "Tablets"]
      },
      {
        id: "thr",
        name: "Take Home Ration (THR) Scheme", 
        beneficiaries: 4500000,
        distribution: "Monthly",
        content: "Ready-to-cook balanced nutrition packets"
      }
    ],
    womenEmpowerment: [
      {
        id: "vahli-dikri",
        name: "Vahli Dikri Yojana",
        beneficiaries: 230000,
        benefits: {
          class1: 4000,
          class9: 6000, 
          age18: 100000
        }
      },
      {
        id: "ganga-swarupa",
        name: "Ganga Swarupa Pension Scheme",
        beneficiaries: 1649000,
        monthlyAmount: 1250,
        budget: 301500
      }
    ]
  },
  performance: {
    nutritionCoverage: 92,
    digitizationRate: 78,
    immunizationRate: 94,
    enrollmentRate: 87
  },
  districts: wcdMetrics
};

// Function to download data as CSV
export const downloadCSV = (data, filename) => {
  const csvContent = convertToCSV(data);
  const blob = new Blob([csvContent], { type: 'text/csv' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${filename}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

// Function to download data as JSON
export const downloadJSON = (data, filename) => {
  const jsonContent = JSON.stringify(data, null, 2);
  const blob = new Blob([jsonContent], { type: 'application/json' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${filename}.json`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

// Function to download data as Excel
export const downloadExcel = (data, filename) => {
  // This would require a library like xlsx for full Excel support
  // For now, we'll create a CSV with .xlsx extension
  downloadCSV(data, filename + '.xlsx');
};

// Helper function to convert object to CSV
const convertToCSV = (data) => {
  if (Array.isArray(data)) {
    if (data.length === 0) return '';
    
    const headers = Object.keys(data[0]);
    const csvHeaders = headers.join(',');
    const csvRows = data.map(row => 
      headers.map(header => {
        const value = row[header];
        return typeof value === 'string' ? `"${value}"` : value;
      }).join(',')
    );
    
    return [csvHeaders, ...csvRows].join('\n');
  } else {
    // Convert object to key-value CSV
    const rows = Object.entries(data).map(([key, value]) => 
      `"${key}","${typeof value === 'object' ? JSON.stringify(value) : value}"`
    );
    return ['Key,Value', ...rows].join('\n');
  }
};